import { useHttpClient } from "../http-client";
import { ApiResponseStatistics } from "../types/api-response-statistics";
import { useQuery } from "@tanstack/react-query";
import { useSupervisorMode } from "../../components/supervisor-mode-provider";
import { useGetCurrentUserApi } from "./use-get-current-user-api";

export const useGetResponseStatisticsApi = (
  searchQuery: string,
  params?: {
    refetchOnMount?: boolean;
    enabled?: boolean;
  }
) => {
  const http = useHttpClient();
  const isSupervisorMode = useSupervisorMode();
  const { data: currentUser } = useGetCurrentUserApi();

  const getStatistics = async ({
    signal,
  }: {
    signal: AbortSignal;
  }): Promise<ApiResponseStatistics[]> => {
    const result = await http.get("/classifier/response_statistics", {
      params: {
        term: searchQuery,
        supervisor: isSupervisorMode,
      },
      signal,
    });

    return result.data.data;
  };

  return useQuery({
    queryKey: ["dashboard", searchQuery, isSupervisorMode, currentUser?.id],
    queryFn: getStatistics,
    ...params,
  });
};
